module.exports = __webpack_public_path__ + "img/Company-registration-information.b8686b3b.png";